import type { StudentRatingPerformance } from './Performance';

export type StudyUnit = {
    studyUnitNumber: number;
};

export type Stage = {
    stageNumber: number;
    studyUnits: StudyUnit[];
};

export type Rating = {
    stages: Stage[];
};

/**
 * Pull stages -> study units hierarchy out of a StudentRatingPerformance.
 * May be better to add a separate API request to get the content hierarchy. I don't want to
 * set up mock data for this right now.
 */
export function extractRatingFromPerformances(
    studentPerformance: StudentRatingPerformance,
): Rating {
    const stages: Stage[] = [];

    studentPerformance.studyUnitPerformance.forEach((studyPerformance) => {
        let stage = stages.find(
            (checkStage) => checkStage.stageNumber === studyPerformance.stageNumber,
        );

        if (stage === undefined) {
            stage = { stageNumber: studyPerformance.stageNumber, studyUnits: [] };
            stages.push(stage);
        }

        let studyUnit = stage.studyUnits.find(
            (unit) => unit.studyUnitNumber === studyPerformance.studyUnitNumber,
        );

        if (studyUnit === undefined) {
            studyUnit = { studyUnitNumber: studyPerformance.studyUnitNumber };
            stage.studyUnits.push(studyUnit);
        }
    });

    return { stages };
}
